import Vue from 'vue'
export const orderPagiation = {
  namespaced: true,
  state: () => ({
    paginationOrdersStateParams: {
      count: 0,
      limit: 100,
      total: 0,
      page: 0
    }
  }),

  getters: {
    numPages: (state) =>
      Math.ceil(
        state.paginationOrdersStateParams.total /
          state.paginationOrdersStateParams.limit
      )
  },
  mutations: {
    update_pagination(state, { total, count, limit, page }) {
      state.paginationOrdersStateParams = { total, count, limit, page }
    }
  },
  actions: {
    getOrdersAll({ commit }, pagination) {
      commit('update_pagination', pagination)
    }
  }
}
